import "./banner/Banner.css";
import Banner from "./banner/Banner";
import Specialization from "./specialization/Specialization";
import Home_about_us from "./home_about_us/Home_about_us";
import Our_product from "./our_product/Our_product";
import Our_presence from "./our_presence/Our_presence";
import Group_of_companies from "./group_of_companies/Group_of_companies";
import Get_in_touch from "../get_in_touch/Get_in_touch";

function Home() {
  return (
    <>
      <Banner />
      <Specialization />
      <Home_about_us />
      <Our_product />
      <Our_presence />
      <Group_of_companies />
    </>
  );
}

export default Home;
